export var SelectTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        select: function (_a) {
            var theme = _a.theme;
            return ({
                minHeight: 40,
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                boxSizing: "border-box",
                '&.MuiInputBase-inputSizeSmall': {
                    lineHeight: theme.spacing(2.75),
                    minHeight: 32,
                    paddingTop: theme.spacing(0.5),
                    paddingBottom: theme.spacing(0.5), //4,
                },
            });
        },
        // icon: {
        //   path: {
        //     d: `path("m1844 760 4-8h-8l4 8")`,
        //     transform: `translate(-1832.001px, -744px)`,
        //   },
        // },
    },
}); };
export default SelectTheme;
//# sourceMappingURL=theme.js.map